import { useEffect, useState } from "react";
import api from "../services/api";
import "../styles/pos.css";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [form, setForm] = useState({
    username: "",
    full_name: "",
    role: "CASHIER",
    branch_id: ""
  });

  const loadUsers = async () => {
    const res = await api.get("/users");
    setUsers(res.data || []);
  };

  const loadBranches = async () => {
    const res = await api.get("/branches");
    setBranches(res.data || []);
  };

  const toggleUserStatus = async (user) => {
  const confirmMsg = user.is_active
    ? "Disable this user?"
    : "Enable this user?";

  if (!window.confirm(confirmMsg)) return;

  try {
    await api.patch(`/users/${user.user_id}/status`, {
      is_active: !user.is_active
    });

    loadUsers();
  } catch (err) {
    alert(err.response?.data?.error || "Action failed");
  }
};

  useEffect(() => {
    loadUsers();
    loadBranches();
  }, []);

  const handleChange = e => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const addUser = async () => {
    if (!form.username || !form.full_name) {
      alert("Username and Full Name required");
      return;
    }

    if (form.role === "CASHIER" && !form.branch_id) {
    alert("Cashier must be assigned to a branch");
    return;
  } 

    try {
      await api.post("/users", {
        ...form,
        branch_id: form.branch_id || null
      });

      setForm({
        username: "",
        full_name: "",
        role: "CASHIER",
        branch_id: ""
      });
      setShowForm(false);
      loadUsers();
    } catch (err) {
      alert(err.response?.data?.error || "Failed to add user");
    }
  };

  return (
    <div className="page-container">
      {/* ===== HEADER ===== */}
      <div className="page-header">
        <h2>Users</h2>
        <button
          className="primary-btn"
          onClick={() => setShowForm(!showForm)}
        >
          ➕ Add User
        </button>
      </div>

      {/* ===== ADD USER FORM ===== */}
      {showForm && (
        <div className="card">
          <h4>Add New User</h4>

          <div className="form-row">
            <input
              name="username"
              placeholder="Username"
              value={form.username}
              onChange={handleChange}
            />
            <input
              name="full_name"
              placeholder="Full Name"
              value={form.full_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <select
              name="role"
              value={form.role}
              onChange={handleChange}
            >
              <option value="SUPER_ADMIN">SUPER ADMIN</option>
              <option value="ADMIN">ADMIN</option>
              <option value="MANAGER">MANAGER</option>
              <option value="CASHIER">CASHIER</option>
            </select>

            <select
              name="branch_id"
              value={form.branch_id}
              onChange={handleChange}
            >
              <option value="">Select Branch</option>
              {branches.map(b => (
                <option key={b.branch_id} value={b.branch_id}>
                  {b.branch_name}
                </option>
              ))}
            </select>
          </div>

          <button className="primary-btn" onClick={addUser}>
            Save User
          </button>
        </div>
      )}

      {/* ===== USER LIST ===== */}
      <div className="invoice-table print-container">
      <table>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Username</th>
            <th>Role</th>
            <th>Branch</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.user_id}>
              <td><b>{u.full_name}</b></td>
              <td>{u.username}</td>
              <td>{u.role}</td>
              <td>{u.branch?.branch_name || "All"}</td>
              <td>
                <span className={`badge ${u.is_active ? "active" : "inactive"}`}>
                  {u.is_active ? "Active" : "Disabled"}
                </span>
              </td>
              <td>
  <button
    className={`small-btn ${
      u.is_active ? "danger-btn" : "success-btn"
    }`}
    onClick={() => toggleUserStatus(u)}
  >
    {u.is_active ? "Disable" : "Enable"}
  </button>
</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Users;
